var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { GrayRadioBadgeWrapper, GrayRadioBadgeRow, GrayRadioBadge, } from './styles';
var RadioBadge = function (_a) {
    var selected = _a.selected, _b = _a.options, options = _b === void 0 ? [] : _b, onChange = _a.onChange;
    return (_jsx(GrayRadioBadgeWrapper, { children: _jsx(GrayRadioBadgeRow, { children: options.map(function (option) { return (_jsx(GrayRadioBadge, __assign({ onClick: function () { return onChange(option.value); }, active: option.value === selected }, { children: option.label }), option.value)); }) }) }));
};
export default RadioBadge;
